import * as React from 'react';
import { LoaderCircle } from 'lucide-react';
import { FloatingNotificationCard } from '@klareospace/pharos-lib-web-utils';
import { useTranslation } from 'react-i18next';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface ImportPendingPopupProps {
  onDismiss: () => void;
}

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * Composes `FloatingNotificationCard` for the "import in progress" notification — same slot,
 * position and animation as `ImportCompletionPopup`, so both notifications appear identically.
 * No description: it carries only a spinner icon and the existing `upload.successToast` copy
 * (asserted verbatim by the e2e suite).
 */
export function ImportPendingPopup({ onDismiss }: ImportPendingPopupProps): React.JSX.Element {
  const { t } = useTranslation('imports');

  return (
    <FloatingNotificationCard
      closeLabel={t('notificationCard.close')}
      icon={<LoaderCircle className="mt-0.5 h-5 w-5 shrink-0 animate-spin text-muted-foreground" />}
      onClose={onDismiss}
      title={t('upload.successToast')}
    />
  );
}
